<template>
    <v-menu
        :absolute="absolute"
        :attach="attach"
        :content-class="`right no-absolute ${textAlignEnd ? 'align-end' : ''} ${rounded ? 'menu-rounded' : ''}`"
        :position-x="positionX"
        :position-y="positionY"

        :transition="transition"
        :value="value"
        style="right: 0;"

    >
        <v-list>
            <v-list-item
                v-for="(item, index) in items"
                :key="index"
                :class="item.class"
                :href="(value && item.href) ? item.href(id) : undefined"
                @click="onItemClick(item)">

                <v-list-item-icon v-if="item.icon">
                    <v-icon small v-text="item.icon" />
                </v-list-item-icon>
                <v-list-item-title v-text="item.label" />
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'list-dropdown-menu',
    props: {
        attach: {
            type: [String, Object, Boolean],
            default: false
        },
        value: {
            type: Boolean,
            required: true
        },
        id: {
            type: [String, Number],
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        textAlignEnd: Boolean,
        transition: {
            type: String,
            default: 'slide-y-transition'
        },
        absolute: {
            type: Boolean,
            default: false
        },
        positionX: {
            type: Number,
            default: undefined
        },
        positionY: {
            type: Number,
            default: undefined
        },
        rounded: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onItemClick(item) {
            if (!this.value || item.href) return // Prevent items from being clicked when the menu is closing (they are still active)
            item.command(this.id)
        }
    }

})
</script>
